export default function unslugify(str: string): string {
    return str.replace(/-/g, '.');
}
